<template>
  <b-row class="d-flex justify-content-around align-items-center">
    <template v-for="(value, key) in values">
      <div class="campaign-score-block d-flex flex-column justify-content-center align-items-center" :key="`${key}-block`">
        <span class="score-display-count">{{ value }}</span>
        <span class="score-display-label" v-if="labels && labels[key]">{{ labels[key] }}</span>
        <span class="score-display-label" v-else>{{ key | _startCase }}</span>
      </div>
      <span class="text-secondary" v-if="key !== lastKey" :key="`${key}-chevron`">
        <font-awesome-icon icon="chevron-right" />
      </span>
    </template>
  </b-row>
</template>

<script>
import _startCase from 'lodash/startCase';

export default {
  props: {
    labels: {
      type: Object,
      default: null,
    },
    values: {
      type: Object,
      required: true,
    },
  },
  filters: {
    _startCase: value => _startCase(value),
  },
  computed: {
    lastKey() {
      return Object.keys(this.values).pop();
    },
  },
};
</script>

<style lang="scss">
.campaign-score-block {
  width: 84px;

  .score-display-count {
    font-weight: bold;
    font-size: 23px;
  }
  .score-display-label {
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/campaign-dashboard/score-block.vue